import type { AnalysisReplay } from '@/shared/contracts/analytics/v1';
import type { AnalysisReplayRun } from '@/shared/contracts/analytics/client';

export type ReplayPresentation = {
  frames: AnalysisReplay;
  source: 'live' | 'fixture';
  frameIndex: number;
};

/** Seed the control state from the recording, ready at its final frame. */
export function recordedPresentation(frames: AnalysisReplay): ReplayPresentation {
  return { frames, source: 'fixture', frameIndex: Math.max(0, frames.length - 1) };
}

/** Upgrade to the service frames at the same instant (or nearest available instant). */
export function upgradePresentation(
  current: ReplayPresentation,
  service: AnalysisReplayRun,
): ReplayPresentation {
  const selectedAt = current.frames[current.frameIndex]?.at;
  if (!selectedAt || service.frames.length === 0) {
    return { frames: service.frames, source: service.source, frameIndex: 0 };
  }

  const selectedTime = Date.parse(selectedAt);
  let frameIndex = 0;
  let smallestDistance = Number.POSITIVE_INFINITY;
  for (let index = 0; index < service.frames.length; index += 1) {
    const distance = Math.abs(Date.parse(service.frames[index]!.at) - selectedTime);
    if (distance < smallestDistance) {
      smallestDistance = distance;
      frameIndex = index;
    }
  }

  return { frames: service.frames, source: service.source, frameIndex };
}
